export interface QuickLinksApiResponse {
    quickLinks: QuickLink[];
    curatedSearchTerms: string[];
}

export interface QuickLink {
    label: string;
    href: string;
}

export type AutoSuggestClickType = "curatedSearchTerm" | "suggestion";
